import languageJsonEs from './language_es.json';
import languageJsonEn from './language_en.json';

// Goto https://www.w3schools.com/JSREF/jsref_tolocalestring.asp to find the date style for your country.
export const dateStyle = 'en-US';
export const timeZone = 'America/Santo_Domingo';
export const language = {
    en: languageJsonEn,
    es: languageJsonEs,
}